import { defineStore } from "pinia";
import { ref } from "vue";

export const useErrorsStore = defineStore("errors", () => {

  const errors = ref([]);

  const pushError = function (error) {
    errors.value.push(error);
  }

  const pushErrorCode = function (errorCode, fatal) {
    const error = {
      fatal: fatal,
      message: errorMap[errorCode] ?? errorMap['unknown-cause']
    }
    pushError(error)
  }

  const resetStore = function () {
    errors.value = [];
  }

  const errorMap = {
    'entity-used': 'Record non eliminabile',
    'user-not-found': 'Utente non trovato',
    'user-exists': 'Utente già utilizzato',
    'company-not-found': 'Partecipante non trovata',
    'auth0-error': 'Errore di autenticazione',
    'invalid-payload': 'Payload invalido',
    'entity-too-large': 'Allegato troppo grande',
    'unknown-cause': 'Errore sconosciuto',
  }

  return { errors, pushError, pushErrorCode, resetStore };
});
